export default __webpack_public_path__ + "static/media/marker-icon.4e401866.svg";